import Image from 'next/image';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import style from './calender.module.scss';

const CalenderInput = forwardRef(function CalenderInput(props, ref) {
  const { icon, placeholderText, value, onClick } = props;

  return (
    <div
      className={style.inputContainer}
      onClick={onClick}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          // note: keyCode, not keycode
          onClick();
        }
      }}
      role="presentation"
      ref={ref}
    >
      <input
        className={style.input}
        type="text"
        placeholder={placeholderText}
        value={value || ''}
        readOnly
      />

      <div className={style.counter}>
        <Image className={style.inputIcon} src={icon} alt="icon" width={30} height={30} />
      </div>
    </div>
  );
});

CalenderInput.propTypes = {
  value: PropTypes.string,
  placeholderText: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
};

export default CalenderInput;
